export default async function getSettingMenu() {
  return [
    {
      key: 'companys',
      icon: 'fe fe-package',
      url: '/companies',
      permission: 'company_view',
    },
    {
      key: 'userandroles',
      icon: 'fe fe-users',
      url: '/users',
      permission: 'user_view',
    },
    {
      icon: 'fe fe-paperclip',
      key: 'protocolAssignment',
      url: '/protocolAssignment',
      permission: 'protocol_assignment_manage',
    },
    {
      icon: 'fe fe-mail',
      key: 'emailDeliverys',
      url: '/emailDeliverys',
      permission: 'email_manage',
    },
    {
      icon: 'fe fe-send',
      key: 'pushnotifications',
      url: '/pushnotifications',
      permission: 'notification_manage',
    },
    {
      icon: 'fe fe-shield',
      key: 'permissionsManagement',
      url: '/permissions',
      permission: 'permission_manage',
    },
  ]
}
